import React from "react";
import { Switch, Case } from 'react-if'
import { Table } from 'reactstrap'
import { FaHourglassHalf, FaCheck, FaTimes } from "react-icons/fa"
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

function TableApproval({ ApproveLists }) {
	const { t } = useTranslation()
	const { leaveApproval } = ({ ...ApproveLists, ApproveLists })

	return (
		<>
			<Table striped>
				<thead>
					<tr>
						<th>
							#
						</th>
						<th>
							{t("t_approver")}
						</th>
						<th>
							{t("t_status")}
						</th>
						<th>
							{t("t_app_date")}
						</th>
					</tr>
				</thead>
				<tbody>
					{leaveApproval.length > 0 ? (
						leaveApproval.map((approval, index) => {
							return (
								<tr key={index}>
									<th scope="row">
										{index + 1}
									</th>
									<td>
										{approval.employees.FIRST_NM}
									</td>
									<td>
										<Switch>
											<Case condition={parseInt(approval.APP_STATUS) === 0}>
												<span class="badge bg-info" style={{ color: '#fff' }}> <FaHourglassHalf /> </span>
											</Case>
											<Case condition={parseInt(approval.APP_STATUS) > 0}>
												<span class="badge bg-success" style={{ color: '#fff' }}> <FaCheck /> </span>

											</Case>
											<Case condition={parseInt(approval.APP_STATUS) < 0}>
												<span class="badge bg-warning" style={{ color: '#fff' }}> <FaTimes /> </span>
											</Case>

										</Switch>
									</td>
									<td>
										{approval.UPDTD !== null ? format(new Date(approval.UPDTD), 'dd/MM/yyyy') : ''}
									</td>
								</tr>
							)
						})
					) :
						<div className='d-flex justify-content-center'>
							<p className="lead">
								{t("t_no_data")}
							</p>
						</div>
					}
				</tbody>
			</Table>
		</>
	);
}

export default TableApproval;
